export default {
  typeSelect: {
    marginBottom: 30,
  },
};
